module.exports = __webpack_public_path__ + "12df2a5bbd9f8a55a9e8e9af406cbb3d.png";